/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const createProjectDtoSourceTypeEnum = {
    "FRAGMENT": "FRAGMENT"
} as const;

export type CreateProjectDtoSourceTypeEnum = (typeof createProjectDtoSourceTypeEnum)[keyof typeof createProjectDtoSourceTypeEnum];

/**
 * @description Payload to create a new video editor project
*/
export type CreateProjectDto = {
    /**
     * @type string
    */
    sourceType: CreateProjectDtoSourceTypeEnum;
    /**
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @minLength 1
     * @type string
    */
    name: string;
    /**
     * @description Project base config (e.g. video/captions URLs)
     * @type object | undefined
    */
    config?: {
        /**
         * @type string | undefined, uri
        */
        videoUrl?: string;
        /**
         * @type string | undefined, uri
        */
        captionsUrl?: string;
    };
};